<template>
  <!-- 喵喵商品活动 -->
  <div id="promotion" v-if="this.ppadmin_data">
    <div v-html="promotion" class="content"></div>
  </div>
</template>

<script>
import GA4EventApi from "@/utils/GA4EventApi";
import { mapState } from "vuex";
export default {
  name: "PromotionView",
  computed: {
    ...mapState("headerNav", ["ppadmin_data"]),
    promotion() {
      return this.ppadmin_data[3].data;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.attachClickHandlers();
    });
  },
  methods: {
    attachClickHandlers() {
      try {
        if (this.$el.querySelectorAll) {
          // google
          var myGA4EventApi = new GA4EventApi();
          let items = [];
          // google结束
          const elements = this.$el.querySelectorAll("img[data-href]");
          elements.forEach((element) => {
            const dataHref = element.getAttribute("data-href");
            const url = dataHref;
            const segments = url.split("/"); // 将 URL 分割成数组
            const lastSegment = segments.pop(); // 获取数组的最后一个元素，即 "27"

            items.push({
              name: element.getAttribute("alt"),
              id: lastSegment,
            });

            element.style.cursor = "pointer";
            element.addEventListener("click", () => {
              // 判断当前点击的元素是否是图片
              if (element.tagName.toLowerCase() === "img") {
                // 在当前页面中跳转

                const url = dataHref;
                const segments = url.split("/"); // 将 URL 分割成数组
                const lastSegment = segments.pop(); // 获取数组的最后一个元素，即 "27"

                if (lastSegment != "") {
                  // google
                  myGA4EventApi.select_promotion("促銷活動", {
                    name: element.getAttribute("alt"),
                    id: lastSegment,
                  });
                  // goole结束

                  this.$router.push("/detail/" + lastSegment);
                }
              }
            });
          });

          // google
          setTimeout(() => {
            myGA4EventApi.view_promotion("促銷活動", items);
          }, 2000);
          // google结束
        }
      } catch (error) {
        console.log("promotion_ERROR:", error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#promotion {
  .mobile({ ::v-deep .content {
    img {
      width: 100% !important;
    }
  }});
}
</style>
